import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'invoiceType'
})
export class InvoiceTypePipe implements PipeTransform {


  transform(value: string, lang: string = 'fa'): any {
    const extra = (lang === 'fa' ? 'خرید حجم' : 'Traffic');
    const service = (lang === 'fa' ? 'سرویس' : 'Service');
    const item = (lang === 'fa' ? 'خرید تجهیزات' : 'Items');
    const credit = (lang === 'fa' ? 'افزایش اعتبار' : 'Credit');
    switch (value) {
      case 'E':
        return extra;
      case 'S':
        return service;
      case 'I':
        return item;
      case 'C':
        return credit;
    }
  }

}
